import { StyleSheet, Text, View } from "react-native";

import { Icon, type IconName } from "../Icon/Icon";
import type { UiTheme } from "../theme";

// THE empty-state primitive (CN-3 census: ~18 hand-rolled copies). One
// quiet centred column — optional glyph, a one-line title, an optional
// explanatory sub — encoded once so empty buckets read identically
// everywhere. Display-only; if a surface wants a call-to-action it
// composes its own button below (the CTA is the surface's concern, the
// "nothing here" voice is this primitive's).

export type EmptyStateProps = {
  theme: UiTheme;
  title: string;
  sub?: string;
  icon?: IconName;
};

export function EmptyState({ theme, title, sub, icon }: EmptyStateProps) {
  const styles = makeStyles(theme);
  return (
    <View style={styles.wrap}>
      {icon ? (
        <Icon
          name={icon}
          size={theme.typography.sizes.xl}
          color={theme.palette.ink3}
        />
      ) : null}
      <Text style={styles.title}>{title}</Text>
      {sub ? <Text style={styles.sub}>{sub}</Text> : null}
    </View>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, spacing: s, typography: t } = theme;
  return StyleSheet.create({
    wrap: {
      alignItems: "center",
      gap: s.s2,
      paddingVertical: s.s6,
      paddingHorizontal: s.s5,
    },
    title: {
      color: p.ink2,
      fontSize: t.sizes.sm,
      fontWeight: "600",
      textAlign: "center",
    },
    // sm, not xs: the sub is full prose, and xs is reserved for
    // uppercase micro-labels (legibility under the system font scale).
    sub: {
      color: p.ink3,
      fontSize: t.sizes.sm,
      textAlign: "center",
    },
  });
}
